












































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Prop, Watch, PropSync } from 'vue-property-decorator';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import DateCalendar from '@/components/common/datepicker/DateCalendar.vue';
import CheckIcons from './CheckIcons.vue';
import { SalesUnit, PlaceOrigin, StandardCategory } from 'supporter';
import AdditionalManageCode from './AdditionalManageCode.vue'

import { getToday, addDay } from '@/utils/dateUtils';
import { ncpPopup } from '@/utils/ncp';
import { getCurrency } from '@/utils/commonUtils';

const emojiRegex = require('emoji-regex');

@Component({
  components: {
    PeriodDateCalendar,
    DateCalendar,
    CheckIcons,
    AdditionalManageCode
  },
})
export default class SalesInformation extends Vue {
  @Prop({ required: true }) private product!: any;
  @Prop({ required: true }) private error!: any;
  @Prop({ required: true }) private accumulationUseYnDisabled!: boolean;
  @Prop({ required: true }) private categoryCommissionUseYn!: boolean;
  @Prop({ required: true }) private isOption!: any;
  @Prop({ required: true }) private isMapping!: any;
  @Prop({ required: true }) salesUnits!: SalesUnit[];
  @Prop({ required: true }) immutableFields!: string[];
  @Prop({ required: true }) firstInitDataChange!: boolean;
  @Prop({ required: true }) buyInfo!: any;
  @Prop({ required: true }) placeOrigins!: PlaceOrigin[];
  @Prop({ required: true }) selectedPlaceOrigin!: any;
  @Prop({ required: true }) standardCategory!: StandardCategory;
  @Prop({ required: true }) standardCategories!: StandardCategory[];
  @Prop({ required: true }) private partner!: any;
  @Prop({ required: true }) private roundingRule!: any;
  @PropSync('selectRefund', { required: true }) private selectRefundSync: boolean;
  
  private getCurrency = getCurrency;
  private displayPromotionHelpFlag = false;
  private refundTooltipFlag = false;
  private iconTooltipFlag = false;
  private allComparingPrice = true;
  private displayRestockHelpFlag = false;
  private discountIsNotTenUnit = false;
  private discountRangeOut = false;
  private showCommissionRateType = true;
  private salePriceIsNotTenUnit = false;
  private originComparingPriceSiteInfo = null;
  private openSea = '';

  private deleteIconsError() {
    this.$emit('deleteError', ['INVALID_STICKER'])
  }

  created() {
    this.manufactureYmdtOption.placeholder = this.$t(this.manufactureYmdtOption.placeholder) as string;
    this.expirationYmdtOption.placeholder = this.$t(this.expirationYmdtOption.placeholder) as string;
		this.isNotEditMode && this.allComparingPriceChanged({
			target: {
				checked: true
			}
		} as any)
  }

  get selectedOpenSeaDepth1() {
    return this.openSea;
  }

  set selectedOpenSeaDepth1(depth1) {
    this.openSea = depth1;

    /* 원양산일 때 depth1 선택 값 (placeOriginInfo.placeOriginSeq) */
    this.$emit('setOpenSea', depth1)
  }

  @Watch('selectedPlaceOrigin', {immediate: true, deep: true})
  updateSelectedPlaceOriginValue() {
    if (this.selectedPlaceOrigin.placeOrigin && this.selectedPlaceOrigin.selectedOriginCountry === this.$t('PRODUCT_ADD_PLACE_OC')) {
      const { originNo } =  this.selectedPlaceOrigin.placeOrigin;

      this.selectedOpenSeaDepth1 = originNo;
     }
  }

  private manufactureYmdtOption = {
    name: 'manufactureYmdt',
    placeholder: 'PRODUCT_ADD_MANUFACTURE_YMDT_SELECT'
  };
  private salePeriodInfoStartYmdtOption = {
    dateType: 'YmdHm',
    name: 'salePeriodInfoStartYmdt',
    fromRanges: getToday()
  };
  private salePeriodInfoEndYmdtOption = {
    dateType: 'YmdHm',
    name: 'salePeriodInfoEndYmdt',
    fromRanges: getToday(),
    endDate: true
  };
  private deliveryYmdtOption = {
    dateType: 'YmdHm',
    name: 'deliveryYmdt',
    fromRanges: addDay(this.product.reservationInfoModel.startYmdt, 1),
    onOpen: () => {
      this.$emit('deleteError', ['INVALID_RESERVATION_DELIVERY_DATE', 'INVALID_RESERVATION_USE_YN']);
    },
  };
  private expirationYmdtOption = {
    name: 'expirationYmdt',
    placeholder: 'PRODUCT_ADD_EXPIRATION_YMDT_SELECT',
  };
  private reservationInfoOption = {
    dateType: 'YmdHm',
    havePeriodBtn: false,
    name: 'reservationInfo',
    period: '7d',
    onStartOpen: () => {
      this.$emit('deleteError', [
        'INVALID_RESERVATION_DELIVERY_DATE',
        'INVALID_RESERVATION_PERIOD_AFTER_SALE_START_DATE',
        'INVALID_RESERVATION_PERIOD',
        'INVALID_RESERVATION_USE_YN',
      ]);
    },
    onEndOpen: () => {
      this.$emit('deleteError', [
        'INVALID_RESERVATION_DELIVERY_DATE',
        'INVALID_RESERVATION_PERIOD_AFTER_SALE_START_DATE',
        'INVALID_RESERVATION_PERIOD',
        'INVALID_RESERVATION_USE_YN',
      ]);
    },
  };
  private immediateDiscountPeriodOption = {
    fromRanges: getToday(),
    dateType: 'YmdHm',
    havePeriodBtn: false,
    name: 'immediateDiscountPeriod',
  };

  @Watch('product.classType')
  private onClassTypeChanged() {
    if (this.product.classType === 'RENTAL') {
      this.buyInfo.minBuyYn = 'N';
      this.buyInfo.maxBuyYn = 'Y';
      this.buyInfo.maxPurchaseType = 'TIME'
      this.product.maxBuyCountInfo.maxBuyTimeCnt = '1';
    }
  }

  @Watch('product.promotionInfo.promotionYn')
  private onProductPromotionInfoYn() {
    if (this.product.promotionInfo.promotionYn === 'Y') {
      this.product.promotionInfo.additionalDiscountYn = 'Y';
      this.product.promotionInfo.couponYn = 'Y';
      this.product.promotionInfo.freeGiftYn = 'Y';
    }
  }

  @Watch('product.salePeriodInfo.periodType')
  onSalePeriodTypeChanged(newVal: string) {
    if (newVal === 'REGULAR') {
      this.product.salePeriodInfo.endYmdt = '2030-12-31 23:59:59';
      (this.$refs.salePeriodInfoYmdt as any).editOption({ period: '', periodTypes: [] });
    } else {
      (this.$refs.salePeriodInfoYmdt as any).editOption({periodTypes: ['td', '7d', '30d', '60d', '90d']});
      // this.product.salePeriodInfo.endYmdt === '2030-12-31 23:59:59' 이게 왜 들어간지는 확인 안됨
      // if (this.product.salePeriodInfo.endYmdt === '2030-12-31 23:59:59') {
      //   this.product.salePeriodInfo.endYmdt = addDay(new Date(this.product.salePeriodInfo.startYmdt), 90) + ' 23:59:59';
      //   (this.$refs.salePeriodInfoYmdt as any).editOption({period: '90d', periodTypes: ['td', '7d', '30d', '60d', '90d']});
      // } else {
      //   (this.$refs.salePeriodInfoYmdt as any).editOption({periodTypes: ['td', '7d', '30d', '60d', '90d']});
      // }
    }
  }
  private salePeriodInfoYmdtOption: any = {
    dateType: 'YmdHm',
    periodTypes: [],
    name: 'salePeriodInfoYmdt',
    endPeriod: true,
    period: '90d',
  };
  setMaxImmediateDiscountWon() {
    const max = this.product.salePrice + this.minOptionAddPrice;
    this.product.maxImmediateDiscountWon = max > 0 ? max : 0;
  }
  get maxImmediateDiscountRate() {
    const canDiscountPrice =
      this.product.salePrice + this.minOptionAddPrice < 0 ? 0 : this.product.salePrice + this.minOptionAddPrice;
    let rate = Math.floor((canDiscountPrice / this.product.salePrice) * 100);
    return this.product.salePrice ? rate : 0;
  }
  setDiscountPrice() {
    const isWon = this.product.immediateDiscountInfo.unitType === 'AMOUNT';
    let discountAmt = 0;
    if (isWon) {
      discountAmt = this.product.immediateDiscountInfo.amount;
    } else {
      const discountRateAmt = (this.product.salePrice * this.product.immediateDiscountInfo.amount) / 100;
      if (this.roundingRule && discountRateAmt) {
        const { roundingMode, scale } = this.roundingRule;
        const scaled = Math.pow(10, scale);
        const scaledDiscountRateAmt = discountRateAmt * scaled;
        if (roundingMode === 'DOWN') {
          discountAmt = Math.floor(scaledDiscountRateAmt) / scaled;
        } else if (roundingMode === 'UP') {
          discountAmt = Math.ceil(scaledDiscountRateAmt) / scaled;
        } else {
          // HALF_UP
          discountAmt = Math.round(scaledDiscountRateAmt) / scaled;
        }
      } else {
        discountAmt = discountRateAmt;
      }
    }
    const discountPrice = this.product.salePrice - discountAmt;
    this.product.discountPrice = discountPrice > 0 ? discountPrice : 0;
  }
  // * originType == DEEP_SEA 카테고리 선택 시 원산지 영향
  get getPlaceOriginCountries() {
    const set1 = new Set<string>();
    const set2 = new Set<string>();
    this.placeOrigins.forEach((item) => {
      set1.add(item.originCountry);
      if (item.originCountry !== this.$t('PRODUCT_ADD_PLACE_OC')) {
        set2.add(item.originCountry);
      }
    });
    if (this.product.categoryNo) {
      const standardCategory = this.standardCategories.find((item) => item.depth4CategoryNo === this.product.categoryNo);
      return (standardCategory as StandardCategory).originType === 'DEEP_SEA' ? Array.from(set1) : Array.from(set2);
    } else {
      return set2;
    }
  }
  get getPlaceOriginDepth1() {
    if (this.selectedPlaceOrigin.selectedOriginCountry) {
      const set = new Set<string>();
      const set2 = new Set<{name: string; value: number}>();
      if (this.selectedPlaceOrigin.selectedOriginCountry === this.$t('PRODUCT_ADD_PLACE_KR') || this.selectedPlaceOrigin.selectedOriginCountry === this.$t('PRODUCT_ADD_PLACE_IMPORT')) {
        this.placeOrigins.forEach((item) => {
          if (item.originCountry === this.selectedPlaceOrigin.selectedOriginCountry) {
            set.add(item.depth1);
          }
        });
        return Array.from(set);
      } else {
        this.placeOrigins.forEach((item) => {
          if (item.originCountry === this.selectedPlaceOrigin.selectedOriginCountry) {
            set2.add({name: item.depth1, value: item.originNo});
          }
        });
        return Array.from(set2);
      }
    } else {
      return [];
    }
  }
  get getPlaceOriginDepth2() {
    if (this.selectedPlaceOrigin.selectedPlaceOriginDepth1) {
      const set = new Set<{ name: string; value: number }>();
      this.placeOrigins.forEach(item => {
        if (item.depth1 === this.selectedPlaceOrigin.selectedPlaceOriginDepth1) {
          if (item.depth2 !== this.$t('PRODUCT_ADD_PLACE_SELECT')) {
            set.add({ name: item.depth2, value: item.originNo });
          }
        }
      });
      return Array.from(set);
    } else {
      return [];
    }
  }
  private addAdditionalProduct() {
    if (this.product.saleStatusType !== 'FINISHED') {
      alert(this.$t('PRODUCT_ADD_ERROR_NOT_SERVICE'));
    }
  }
  private allComparingPriceChanged(e: Event) {
    const checked = (e.target as HTMLInputElement).checked;
    if (checked) {
      this.product.comparingPriceSiteInfo.info = ['NAVER', 'FACEBOOK'];
    } else {
      this.product.comparingPriceSiteInfo.info = [];
    }
  }
  @Watch('product.comparingPriceSiteInfo.info')
  onComparingPriceSiteInfoChanged() {
    if (this.product.comparingPriceSiteInfo.info.length === 2) {
      this.allComparingPrice = true;
    } else {
      this.allComparingPrice = false;
    }
  }
  @Watch('product.categoryNo')
  onCategoryNoChanged() {
    // 기존 시스템의 현상보고 추가되 내용
    if (this.isMapping && !this.product.salePrice) {
      this.product.salePrice = 0;
    }
    // 표준 카테고리선택후의 노출되는 desc 내용
    // 표준카테고리 변경 시 등록된 원산지, 인증정보, 카테고리수수료, 미성년자구매여부가 초기화 됩니다.
    if (!this.firstInitDataChange) {
      this.product.certificationInfo.data = [];
      this.product.placeOriginInfo = {
        placeOriginsYn: false,
        placeOrigin: '',
        placeOriginSeq: 0,
      };
      this.selectedPlaceOrigin.selectedOriginCountry = '';
      this.selectedPlaceOrigin.selectedPlaceOriginDepth1 = '';
      this.selectedPlaceOrigin.selectedPlaceOriginDepth2 = '';
    }

    // * 판매수수료 default 선택 조건 파트너 수수료 선택안하고 카테고리 수수료 설정했을경우 default 카테고리
    if (
      !this.firstInitDataChange &&
      this.product.categoryNo &&
      !this.partner.commissionRate &&
      this.standardCategory.commissionRate
    ) {
      this.product.commissionInfo.type = 'CATEGORY';
      this.product.commissionInfo.rate = this.standardCategory.commissionRate;
    }
  }
  @Watch('product.commissionInfo.rate')
  onCommissionInfoRateChanged() {
    if (this.product.saleMethodType !== 'PURCHASE') {
      this.setSupplyPrice();
    }
  }
  @Watch('product.refundableInfo.nonRefundableInfo')
  changeNonRefundInfo() {
    if(this.product.refundableInfo.nonRefundableInfo.length) {
      this.selectRefundSync = false;
    }
  }
  @Watch('product.refundableInfo.refundableYn')
  changeRefundableYn() {
    this.product.refundableYn = this.product.refundableInfo.refundableYn;

    if (this.product.refundableInfo.refundableYn === 'Y') {
      this.selectRefundSync = false;
    }
  }

  private onreservationUseYnChanged(e: Event) {
    const newVal = (e.target as HTMLInputElement).value;
    if (newVal === 'Y') {
      this.product.salePeriodInfo.periodType = 'REGULAR';
      this.product.salePeriodInfo.startYmdt = addDay(new Date(), 1);
      this.product.salePeriodInfo.endYmdt = '2999-12-31 23:59:59';
      this.product.reservationInfoModel.endYmdt = addDay(this.product.reservationInfoModel.startYmdt, 7) + ' 23:59:59';
      this.deliveryYmdtOption.fromRanges = addDay(this.product.reservationInfoModel.startYmdt, 1);
    } else {
      this.product.salePeriodInfo.startYmdt = getToday();
    }
    this.$forceUpdate();
  }

  private changeReservationStart() {
    this.deliveryYmdtOption.fromRanges = addDay(this.product.reservationInfoModel.startYmdt, 1);
  }

  callbackDutyInfo(processedDutyInfo: any) {
    localStorage.removeItem('data');
    (window as any).callbackDutyInfo = null;
    this.product.dutyInfo = processedDutyInfo;
  }
  private clickDutyInfoBtn() {
    this.$emit('deleteError', ['INVALID_DUTY_INFO', 'NON_EDITABLE_DUTY_CONTENT']);
    (window as any).callbackDutyInfo = this.callbackDutyInfo;
    if (this.product.dutyInfo) {
      localStorage.removeItem('data');
      localStorage.setItem('data', JSON.stringify(this.product.dutyInfo));
      if (this.immutableFields.includes('dutyContent')) {
        ncpPopup(
          '/productDuty/readForm?dataCallback=callbackDutyInfo&data=true',
          this.$t('PRODUCT_ADD_DUTY_CONTENT_TITLE'),
          1050,
          860,
        );
      } else {
        ncpPopup(
          '/productDuty/addForm?dataCallback=callbackDutyInfo&data=true',
          this.$t('PRODUCT_ADD_DUTY_CONTENT_TITLE'),
          1050,
          860,
        );
      }
    } else {
      ncpPopup(
        '/productDuty/addForm?dataCallback=callbackDutyInfo',
        this.$t('PRODUCT_ADD_DUTY_CONTENT_TITLE'),
        1050,
        860,
      );
    }
  }
  private addCertification() {
    this.$emit('deleteError', [
      'INVALID_CERTIFICATION_INFO',
      'INVALID_CERTIFICATION_TYPE',
      'INVALID_CERTIFICATION_JSON',
      'NON_EDITABLE_CERTIFICATION_INFO',
    ]);
    if (!this.product.categoryNo) {
      alert(this.$t('PRODUCT_ADD_ERROR_NEED_CATEGORY'));
      return;
    } else {
      (window as any).callbackCertificationInfo = this.callbackCertificationInfo;
      if (this.product.certificationInfo.data.length) {
        ncpPopup(
          `/certification/addForm?dataCallback=callbackCertificationInfo&data=${JSON.stringify(
            this.product.certificationInfo.data,
          )}&categoryNo=${this.product.categoryNo}`,
          this.$t('PRODUCT_COMMON_CERTIFICATION_INFO'),
          1360,
          730,
        );
      } else {
        ncpPopup(
          `/certification/addForm?dataCallback=callbackCertificationInfo&categoryNo=${this.product.categoryNo}`,
          this.$t('PRODUCT_COMMON_CERTIFICATION_INFO'),
          1360,
          730,
        );
      }
    }
  }
  private callbackCertificationInfo(processedCertificationInfo: any) {
    (window as any).callbackCertificationInfo = null;
    this.product.certificationInfo.data = processedCertificationInfo;
  }
  private changedOriginCountry() {
    this.selectedPlaceOrigin.selectedPlaceOriginDepth1 = '';
    if (this.selectedPlaceOrigin.selectedOriginCountry === this.$t('PRODUCT_ADD_PLACE_EX')) {
      this.selectedPlaceOrigin.selectedPlaceOriginDepth1 = this.getPlaceOriginDepth1.length
        ? (this.getPlaceOriginDepth1 as {
            name: string;
            value: number;
          }[])[0].value
        : '';
      this.product.placeOriginInfo.placeOriginSeq = this.selectedPlaceOrigin.selectedPlaceOriginDepth1;
    } else {
      this.product.placeOriginInfo.placeOriginSeq = 0;
    }
    this.selectedPlaceOrigin.selectedPlaceOriginDepth2 = '';
    this.product.placeOriginInfo.placeOrigin = '';
  }
  private changedPlaceOriginDepth1(needSetSeq: boolean) {
    this.selectedPlaceOrigin.selectedPlaceOriginDepth2 = '';
    if (needSetSeq) {
      this.product.placeOriginInfo.placeOriginSeq = this.selectedPlaceOrigin.selectedPlaceOriginDepth1;
    } else {
      this.product.placeOriginInfo.placeOriginSeq = 0;
    }
  }
  private changedPlaceOriginDepth2(e: Event) {
    const value = (e.target as HTMLInputElement).value;
    const findedPlaceOrigin = this.getPlaceOriginDepth2.find(placeOrigin => placeOrigin.name === value) as {
      name: string;
      value: number;
    };
    this.product.placeOriginInfo.placeOriginSeq = findedPlaceOrigin.value;
  }
  private isSelfInput(value: number) {
    if (value) {
      const finded = (this.getPlaceOriginDepth1 as {
        name: string;
        value: number;
      }[]).find(item => {
        return item.value === value;
      });
      if (finded) {
        return (finded as {
          name: string;
          value: number;
        }).name === this.$t('PRODUCT_ADD_PLACE_INPUT')
          ? true
          : false;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  private productManagementCdCheckedResult = true;
  private checkRepetition() {
    if (this.product.saleStatusType !== 'FINISHED') {
      if (!this.product.productManagementCd) {
        alert(this.$t('PRODUCT_ADD_INPUT_MANAGE_CD'));
        return;
      }
      const params: any = {
        mallNo: this.product.mallNo,
        productManagementCd: this.product.productManagementCd,
      };
      if (this.product.hasOwnProperty('mallProductNo')) {
        params.mallProductNo = this.product.mallProductNo;
      }
      this.$api.getProductsCheckManagementCode({ params }).then((ret: any) => {
        this.productManagementCdCheckedResult = ret.data.exist;
        if (this.productManagementCdCheckedResult) {
          this.frontError.productManagementCd = true;
          this.$forceUpdate();
        }
      });
    }
  }
  private commissionInfoTypeChange() {
    this.showCommissionRateType = true;
    if (this.product.commissionInfo.type === 'PARTNER') {
      this.product.commissionInfo.rate = this.partner.commissionRate ? this.partner.commissionRate : 0;
    } else if (this.product.commissionInfo.type === 'CATEGORY') {
      this.product.commissionInfo.rate = this.standardCategory.commissionRate
        ? this.standardCategory.commissionRate
        : 0;
    } else if (this.product.commissionInfo.type === 'PURCHASE_PRICE') {
      this.product.commissionInfo.rate = '';
      if (this.isOption) {
        this.showCommissionRateType = false;
      }
    } else {
      this.product.commissionInfo.rate = '';
    }
  }
	private get isNotEditMode() {
		return this.$route.name !== 'EditProduct'
	}
  get minOptionAddPrice() {
    let price = 0;
    if (this.product.optionType === 'COMBINATION') {
      this.product.options.forEach(option => {
        if (price > option.addPrice) {
          price = Number(option.addPrice);
        }
      });
    }
    return price;
  }
  private validateSalePrice(e: Event) {
    const value = Number(this.replaceAll((e.target as HTMLInputElement).value));
    if (value % 10 !== 0) {
      (this.$refs.salePriceValue as any).focus();
      this.salePriceIsNotTenUnit = true;
      this.product.maxImmediateDiscountWon = 0;
      this.product.discountPrice = 0;
      if (this.product.saleMethodType !== 'PURCHASE') {
        this.product.purchasePrice = 0;
      }
      return;
    } else {
      this.salePriceIsNotTenUnit = false;
    }
    if (value) {
      if (this.product.immediateDiscountInfo.unitType === 'AMOUNT') {
        if (value + this.minOptionAddPrice < this.product.immediateDiscountInfo.amount) {
          const text = this.isOption ? this.$t('PRODUCT_ADD_ERROR_PRICE_OPTION') : this.$t('PRODUCT_ADD_ERROR_PRICE');
          alert(text);
          this.product.salePrice = 0;
          if (this.product.saleMethodType !== 'PURCHASE') {
            this.product.purchasePrice = 0;
          }
          this.product.maxImmediateDiscountWon = 0;
          this.product.discountPrice = 0;
          return;
        }
      } else {
        const isLegalSalePrice =
          value + this.minOptionAddPrice >= (value * this.product.immediateDiscountInfo.amount) / 100;
        if (!isLegalSalePrice) {
          const text = this.isOption ? this.$t('PRODUCT_ADD_ERROR_PRICE_OPTION') : this.$t('PRODUCT_ADD_ERROR_PRICE');
          alert(text);
          this.product.salePrice = 0;
          if (this.product.saleMethodType !== 'PURCHASE') {
            this.product.purchasePrice = 0;
          }
          this.product.maxImmediateDiscountWon = 0;
          this.product.discountPrice = 0;
          return;
        }
      }
    }

    this.setMaxImmediateDiscountWon();
    this.setDiscountPrice();

    if (this.product.saleMethodType !== 'PURCHASE') {
      this.setSupplyPrice();
    }
  }
  replace(str: string) {
    return str.replace(',', '');
  }
  replaceAll(str: string) {
    while (str.includes(',')) {
      str = this.replace(str);
    }
    return str;
  }

  private validateImmediateDiscountAmount(e: Event) {
    const value = Number(this.replaceAll((e.target as HTMLInputElement).value));
    if (this.product.immediateDiscountInfo.unitType === 'AMOUNT') {
      if (value % 10 !== 0) {
        (this.$refs.immediateDiscountValue as any).focus();
        this.discountIsNotTenUnit = true;
        return;
      } else {
        this.discountIsNotTenUnit = false;
      }
      if (this.product.salePrice && value > this.product.maxImmediateDiscountWon) {
        const text = this.isOption
          ? this.$t('PRODUCT_ADD_ERROR_DISCOUNT_PRICE_OPTION')
          : this.$t('PRODUCT_ADD_ERROR_DISCOUNT_PRICE');
        alert(text);
        this.product.immediateDiscountInfo.amount = 0;
        return;
      }
    } else {
      if (value > this.maxImmediateDiscountRate) {
        const text = this.isOption
          ? this.$t('PRODUCT_ADD_ERROR_DISCOUNT_PRICE_OPTION')
          : this.$t('PRODUCT_ADD_ERROR_DISCOUNT_PRICE');
        alert(text);
        this.product.immediateDiscountInfo.amount = 0;
        return;
      }
    }

    this.setDiscountPrice();

    if (this.product.saleMethodType !== 'PURCHASE') {
      this.setSupplyPrice();
    }
  }
  changedUnitType(e: Event) {
    const value = this.replaceAll((e.target as HTMLInputElement).value);
    this.discountIsNotTenUnit = false;
    this.discountRangeOut = false;
    if (value === 'AMOUNT') {
      if (this.product.immediateDiscountInfo.amount % 10 !== 0) {
        (this.$refs.immediateDiscountValue as any).focus();
        this.discountIsNotTenUnit = true;
        return;
      } else if (this.product.immediateDiscountInfo.amount > this.product.maxImmediateDiscountWon) {
        alert(this.$t('PRODUCT_ADD_ERROR_DISCOUNT_PRICE'));
        this.product.immediateDiscountInfo.amount = 0;
        return;
      } else {
        this.setDiscountPrice();
        this.discountIsNotTenUnit = false;
      }
    } else {
      if (this.product.immediateDiscountInfo.amount > 99) {
        alert(this.$t('PRODUCT_ADD_ERROR_DISCOUNT_PRICE'));
        this.product.immediateDiscountInfo.amount = 0;
        this.discountRangeOut = true;
      } else {
        this.setDiscountPrice();
        this.discountRangeOut = false;
      }
    }
  }
  getPositiveNumber(value: any) {
    if (value.indexOf(',') > -1) {
      value = this.replaceAll(value);
    }
    if (value.indexOf('-') > -1) {
      value = value.replace('-', '');
    }
    if (Number.isNaN(Number(value))) {
      value = '0';
    }
    return value;
  }

  setPurchasePrice(e: Event) {
    let value = (e.target as HTMLInputElement).value;
    value = this.getPositiveNumber(value);
    this.product.purchasePrice = Number(value);
  }
  setComma(e: Event) {
    let value = (e.target as HTMLInputElement).value;
    const name = (e.target as HTMLInputElement).name;
    const maxlength = (e.target as HTMLInputElement).maxLength;
    const arr = value.split(',');
    value = arr.join('');
    const isOvertop = value.length > maxlength;
    if (!isOvertop) {
      if (value.match(/[^0-9]+/g)) {
        value = value.replace(/[^0-9]+/g, '');
        this.frontError[name] = true;
      } else {
        this.frontError[name] = false;
      }
      if (name.includes('unitPrice')) {
        this.product.unitPriceInfo.price = value ? Number(value) : value;
      } else if (name.includes('reservationStockCnt')) {
        this.product.reservationInfoModel.stockCnt = value ? Number(value) : value;
      } else if (name.includes('unitName')) {
        this.product.unitPriceInfo.name = value ? Number(value) : value;
      } else if (name.includes('maxBuyPersonCnt')) {
        this.product.maxBuyCountInfo.maxBuyPersonCnt = value ? Number(value) : value;
      } else if (name.includes('immediateDiscountValue')) {
        this.product.immediateDiscountInfo.amount = value ? Number(value) : value;
      } else if (name.includes('maxBuyPeriodCnt')) {
        this.product.maxBuyCountInfo.maxBuyPeriodCnt = value ? Number(value) : value;
      } else if (name.includes('maxBuyDays')) {
        this.product.maxBuyCountInfo.maxBuyDays = value ? Number(value) : value;
      } else if (name.includes('commissionRate')) {
        this.product.purchasePrice = value ? Number(value) : value;
      } else {
        this.product[name] = value ? Number(value) : value;
      }

      this.$forceUpdate();
    }
  }

  private setSupplyPrice() {
    if (this.product.commissionInfo.type === 'PURCHASE_PRICE') {
      return;
    }
    if (this.product.commissionInfo.rate) {
      const fees = (this.product.discountPrice * this.product.commissionInfo.rate) / 100;
      const scaled = Math.pow(10, 1);
      const scaledfees = fees * scaled;
      this.product.purchasePrice = this.product.discountPrice - Math.round(scaledfees) / scaled;
    } else {
      this.product.purchasePrice = this.product.discountPrice;
    }
  }
  private openOption(e: Event) {
    this.$emit('deleteError', [
      'INVALID_OPTION_NAME',
      'INVALID_OPTION_VALUE',
      'INVALID_OPTION_DISPLAY_ORDER',
      'INVALID_OPTION_ADD_PRICE',
      'INVALID_OPTION_USE_YN',
      'INVALID_OPTION_TYPE',
      'INVALID_OPTION_IS_EMPTY',
      'STANDARD_OPTION_ADD_PRICE_MUST_BE_ZERO',
      'INVALID_OPTION_ADD_PRICE_UNIT',
      'INVALID_OPTION_ADD_PRICE_COMPARE_PRICE',
      'INVALID_OPTION_NAME_COUNT',
      'INVALID_OPTION_NAME_SIZE',
      'INVALID_OPTION_VALUE_COUNT',
      'INVALID_OPTION_VALUE_SIZE',
      'INVALID_OPTION_MANAGEMENT_CD_ALLOW_COMBINATION',
      'INVALID_OPTION_MANAGEMENT_CD_LENGTH',
      'OPTION_MUST_HAVE_USE_YN_Y',
      'INVALID_OPTION_IMAGE_MUST_AT_LEAST_TWO',
      'INVALID_OPTION_IMAGE_EMPTY',
      'INVALID_OPTION_DETAIL_IMAGE_COUNT',
      'SYNC_PRODUCT_CANNOT_CHANGE_OPTION',
      'ADD_PRICE_GREATER_THAN_IMMEDIATE_DISCOUNT_APPLY_PRICE',
      'INVALID_MAPPING_OPTION_DELIVERY_TEMPLATE_NO',
      'ONE_OR_MORE_REPRESENT',
      'MORE_THAN_ONE_ADD_PRICE_ZERO',
      'CAN_NOT_DELETE_OPTION'
    ]);
    if (!this.checkMall(e)) {
      return;
    }
    if (this.isMapping) {
      if (!this.product.partnerNo) {
        alert(this.$t('PRODUCT_ADD_INPUT_PARTNER'));
        return;
      }
      if (!this.product.deliveryTemplateNo) {
        alert(this.$t('PRODUCT_ADD_INPUT_DELIVERY_TEMPLATE'));
        return;
      }
    }
    // saleMethodType=CONSIGNMENT
    //mallNo=2173
    //commissionRate=0
    //deliveryTemplateNo=24851
    //commissionRateType=CATEGORY
    //countryCd=
    //useOptionYn=Y
    //partnerNo=10196
    //useRepresentStock=false
    //wmsUsed=false
    (window as any).callbackOptionInfo = this.callbackOptionInfo;
    sessionStorage.setItem('options', JSON.stringify(this.product.options));
    let url = `/option/addForm?dataCallback=callbackOptionInfo&mallNo=${JSON.stringify(
      this.product.mallNo,
    )}&optionType=${this.product.optionType}&options=true&commissionRateType=${
      this.product.commissionInfo.type
    }&applyStatusType=${JSON.stringify(this.product.applyStatusType)}&deliveryTemplateNo=${JSON.stringify(
      this.product.deliveryTemplateNo,
    )}&customerDemands=${JSON.stringify(this.product.customerDemands)}&useReservationStock=${this.product
      .reservationUseYn === 'Y'}&salePrice=${this.product.salePrice}&discountPrice=${
      this.product.immediateDiscountInfo.unitType === 'AMOUNT'
        ? this.product.immediateDiscountInfo.amount
        : (this.product.salePrice * this.product.immediateDiscountInfo.amount) / 100
    }&commissionRate=${this.product.commissionInfo.rate}`;
    if (this.product.synced) {
      if (this.$route.name === 'CopyProduct') {
        url = url + `&isStockSync=${this.product.synced}&masterYn=N`;
      } else {
        url = url + `&isStockSync=${this.product.synced}&masterYn=${this.product.parentNo ? 'N' : 'Y'}`;
      }
    }
    ncpPopup(url, this.$t('PRODUCT_COMMON_OPTIONS'), 1180, 730);
  }
  frontError: any = {
    minBuyCnt: false,
    maxBuyDays: false,
    maxBuyPeriodCnt: false,
    maxBuyTimeCnt: false,
    maxBuyPersonCnt: false,
    hsCode: false,
    salePrice: false,
    partnerChargeAmt: false,
  };
  setStockZeroToEmpty() {
    if (this.product.reservationInfoModel.stockCnt.toString().length > 8) {
      this.product.reservationInfoModel.stockCnt = '';
    }
    if (!this.product.reservationInfoModel.stockCnt || this.product.reservationInfoModel.stockCnt === '0') {
      this.product.reservationInfoModel.stockCnt = '';
    }
  }
  onlyNumber(e: Event, usePoint = false, digits = 1) {
    const target = e.target as HTMLInputElement;
    let value = target.value;
    const name = target.name;
    if (usePoint) {
      if (value.startsWith('.')) {
        this.frontError[name] = true;
        value = '';
      } else if (value.endsWith('.')) {
        value = value.substr(0, value.length - 1);
        if (value.endsWith('.')) {
          value = value.replace(/[^0-9]+/g, '');
          this.frontError[name] = true;
        }
        value = value + '.';
      } else {
        const values = value.split('.');
        if (values.length === 2) {
          if (values[1].length > digits) {
            value = value.substr(0, value.length - 1);
            this.frontError[name] = true;
          } else {
            value = values[0] + values[1];
            if (value.match(/[^0-9]+/g)) {
              value = value.replace(/[^0-9]+/g, '');
              this.frontError[name] = true;
            } else {
              this.frontError[name] = false;
            }
            value = value.substr(0, value.length - digits) + '.' + value.substr(value.length - digits, digits);
          }
        } else {
          if (value.match(/[^0-9]+/g)) {
            value = value.replace(/[^0-9]+/g, '');
            this.frontError[name] = true;
          } else {
            this.frontError[name] = false;
          }
        }
      }
    } else {
      if (value.match(/[^0-9]+/g)) {
        value = value.replace(/[^0-9]+/g, '');
        this.frontError[name] = true;
      } else {
        this.frontError[name] = false;
      }
    }

    this.rangeError[name] = false;
    if (name.includes('maxBuy')) {
      this.product.maxBuyCountInfo[name] = value;
    } else if (name.includes('commissionRate')) {
      this.product.commissionInfo.rate = value;
    } else if (name.includes('unitPrice')) {
      this.product.unitPriceInfo.price = value;
    } else {
      this.product[name] = value;
    }
  }

  hsCodeVal(e) {
    const regex = /[\\`'"*?<>₩]/g;
    let value = e.target.value;
    let name = e.target.name;

    if(value.match(regex)) {
      this.product.hsCode = value.replace(regex, '');
      this.frontError[name] = true;
    } else if(value.match(emojiRegex())) {
      this.product.hsCode = value.replace(emojiRegex(), '');
      this.frontError[name] = true;
    } else {
      this.frontError[name] = false;
      this.product.hsCode = value;
    }
  }

  private checkMall(e: Event): boolean {
    if (!this.product.mallNo) {
      (e.target as HTMLInputElement).blur();
      alert(this.$t('PRODUCT_ADD_REQUIRE_MALL'));
      $('#mallNo').focus();
      return false;
    }
    return true;
  }
  private callbackOptionInfo(optionInfo: any, customerDemands?: any, optionType?: string) {
    (window as any).callbackOptionInfo = null;
    this.product.options = optionInfo;
    this.product.optionType = optionType ? optionType : 'MAPPING';
    if (this.product.optionType === 'COMBINATION') {
      let optionStock = 0;
      let reservationStockCnt = 0;
      this.product.options.forEach((option: any) => {
        optionStock = optionStock + Number(option.stockCnt);
        reservationStockCnt = reservationStockCnt + Number(option.reservationStockCnt);
      });

      this.product.reservationInfoModel.stockCnt = this.product.reservationUseYn === 'Y' ? reservationStockCnt : 0;
      this.product.productStockCnt = optionStock;
      this.setMaxImmediateDiscountWon();
    }

    if (this.product.optionType === 'MAPPING') {
      let salePrice = 0;
      let stockCnt = 0;
      let reservationStockCnt = 0;
      this.product.options.forEach((option: any) => {
        if (salePrice) {
          if (salePrice > option.addPrice) {
            salePrice = option.addPrice;
          }
        } else {
          salePrice = option.addPrice;
        }
        stockCnt = stockCnt + Number(option.stockCnt);
        reservationStockCnt = reservationStockCnt + Number(option.reservationStockCnt);
      });
      this.product.reservationInfoModel.stockCnt = this.product.reservationUseYn === 'Y' ? reservationStockCnt : 0;
      this.product.productStockCnt = stockCnt;
      if (this.product.classType !== 'EVENT') {
        this.product.salePrice = salePrice;
        this.setMaxImmediateDiscountWon();
        this.setDiscountPrice();
        this.setSupplyPrice();
      }
    }
    this.product.customerDemands = customerDemands ? customerDemands : [];
  }
  getOptionButton() {
    if (this.isOption) {
      return this.product.options.length || this.product.customerDemands.length
        ? this.$t('PRODUCT_ADD_OPTION_CHANGE')
        : this.$t('PRODUCT_ADD_OPTION_ADD');
    }
    if (this.isMapping) {
      return this.product.options.length || this.product.customerDemands.length
        ? this.$t('PRODUCT_ADD_SETOPTION_CHANGE')
        : this.$t('PRODUCT_ADD_SETOPTION_ADD');
    }
    return this.$t('PRODUCT_ADD_OPTION_ADD');
  }
  validationCommissionRate(e: Event) {
    const value = (e.target as HTMLInputElement).value;
    if (
      this.product.commissionInfo.type !== 'PURCHASE_PRICE' &&
      ((value && Number(value) < 0) || Number(value) > 99.9)
    ) {
      alert(this.$t('PRODUCT_ADD_ERROR_COMISSION'));
      this.product.commissionInfo.rate = '';
    } else {
      this.frontError.commissionRate = false;
      this.$forceUpdate();
    }
  }
  private rangeError: any = {
    accumulationRate: false,
    minBuyCnt: false,
  };
  blurMinBuyCnt() {
    this.frontError.minBuyCnt = false;
    if (this.product.minBuyCnt < 2) {
      this.product.minBuyCnt = '';
      this.rangeError.minBuyCnt = true;
    }
  }
  checkRange(e: Event, range: number) {
    const target = e.target as HTMLInputElement;
    let value = Number(target.value);
    const name = target.name;

    if (value < 0 || value > range) {
      this.product[name] = '';
      this.rangeError[name] = true;
    } else {
      this.rangeError[name] = false;
    }
  }
  initOption() {
    if (this.product.saleStatusType !== 'FINISHED') {
      if (confirm(this.$t('PRODUCT_ADD_CONFIRM_OPTION_RESET') as string)) {
        this.product.options = [];

        this.product.customerDemands = [];
        if (this.product.optionType === 'MAPPING') {
          this.product.salePrice = '';
        } else {
          this.product.optionType = 'DEFAULT';
        }
        this.product.productStockCnt = 0;
        this.product.reservationInfoModel.stockCnt = 0;
        this.setMaxImmediateDiscountWon();
        this.setDiscountPrice();
        this.setSupplyPrice();
      }
    }
  }
  blurUnitPriceName() {
    if (this.product.unitPriceInfo.name > 999999999) {
      this.rangeError.unitPriceName = true;
      this.product.unitPriceInfo.name = '';
    } else {
      this.rangeError.unitPriceName = false;
      this.frontError.unitName = false;
      this.$forceUpdate();
    }
  }
  blurUnitPricePrice() {
    if (this.product.unitPriceInfo.price > 999999999) {
      this.rangeError.unitPricePrice = true;
      this.product.unitPriceInfo.price = '';
    } else {
      this.rangeError.unitPricePrice = false;
      this.frontError.unitPrice = false;
      this.$forceUpdate();
    }
  }
  focusUnitPriceName() {
    this.rangeError.unitPriceName = false;
    this.$forceUpdate();
  }
  focusUnitPricePrice() {
    this.rangeError.unitPricePrice = false;
    this.$forceUpdate();
  }
  changedStockCnt(e: Event) {
    let value = (e.target as HTMLInputElement).value;
    const arr = value.split(',');
    value = arr.join('');
    const maxlength = (e.target as HTMLInputElement).maxLength;
    this.product.productStockCnt = Number(String(value).substring(0, maxlength - 2));
  }
  changeMaxBuyPersonCnt(e: Event) {
    let value = (e.target as HTMLInputElement).value;
    const arr = value.split(',');
    value = arr.join('');
    const maxlength = (e.target as HTMLInputElement).maxLength;
    this.product.maxBuyCountInfo.maxBuyPersonCnt = Number(String(value).substring(0, maxlength - 2));
  }
  changeMaxBuyPeriodCnt(e: Event) {
    let value = (e.target as HTMLInputElement).value;
    const arr = value.split(',');
    value = arr.join('');
    const maxlength = (e.target as HTMLInputElement).maxLength;
    this.product.maxBuyCountInfo.maxBuyPeriodCnt = Number(String(value).substring(0, maxlength - 2));
  }
  changeMaxBuyDays(e: Event) {
    let value = (e.target as HTMLInputElement).value;
    const arr = value.split(',');
    value = arr.join('');
    const maxlength = (e.target as HTMLInputElement).maxLength;
    this.product.maxBuyCountInfo.maxBuyDays = Number(String(value).substring(0, maxlength - 1));
  }
  changedPeriodType(e: Event) {
    const value = (e.target as HTMLInputElement).value;
    if (value === 'PERIOD') {
      this.product.salePeriodInfo.endYmdt = addDay(this.product.salePeriodInfo.startYmdt, 90) + ' 23:59:59';

      if (this.immutableFields.includes('salePeriodInfo.startYmdt')) {
        const findIndex = this.immutableFields.findIndex(str => str === 'salePeriodInfo.startYmdt');
        this.immutableFields[findIndex] = '';
      }
      if (this.immutableFields.includes('salePeriodInfo.endYmdt')) {
        const findIndex = this.immutableFields.findIndex(str => str === 'salePeriodInfo.endYmdt');
        this.immutableFields[findIndex] = '';
      }
    }
  }
}
